var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heading"},[_c('h1',[_vm._v(_vm._s(_vm.destinationCityName)+" - "+_vm._s(_vm.nameHotel))]),_c('p',[_c('img',{attrs:{"src":"assets/img/theme1/location.png","alt":"location","title":""}}),_vm._v(_vm._s(_vm.nameHotel)+", "+_vm._s(_vm.destinationCityName)+", Israel")])])
}
var staticRenderFns = []

export { render, staticRenderFns }